
// Ionic: Custom Elements Define Library, ES Module/es5 Target

import { defineCustomElement } from './ionic.core.js';
import {
  ActionSheet,
  ActionSheetController,
  Alert,
  AlertController,
  Anchor,
  AnimationControllerImpl,
  App,
  Avatar,
  BackButton,
  Backdrop,
  Badge,
  Button,
  Buttons,
  Card,
  CardContent,
  CardHeader,
  CardSubtitle,
  CardTitle,
  Checkbox,
  Chip,
  ChipButton,
  ChipIcon,
  Col,
  Content,
  Datetime,
  Fab,
  FabButton,
  FabList,
  Footer,
  Grid,
  Header,
  HideWhen,
  Icon,
  Img,
  InfiniteScroll,
  InfiniteScrollContent,
  Input,
  Item,
  ItemDivider,
  ItemGroup,
  ItemOption,
  ItemOptions,
  ItemSliding,
  Label,
  List,
  ListHeader,
  Loading,
  LoadingController,
  Menu,
  MenuButton,
  MenuController,
  MenuToggle,
  Modal,
  ModalController,
  Nav,
  NavPop,
  NavPush,
  NavSetRoot,
  Note,
  Picker,
  PickerColumnCmp,
  PickerController,
  Popover,
  PopoverController,
  Radio,
  RadioGroup,
  Range,
  Refresher,
  RefresherContent,
  Reorder,
  ReorderGroup,
  RippleEffect,
  Route,
  RouteRedirect,
  Router,
  RouterOutlet,
  Row,
  Searchbar,
  Segment,
  SegmentButton,
  Select,
  SelectOption,
  SelectPopover,
  ShowWhen,
  SkeletonText,
  Slide,
  Slides,
  Spinner,
  SplitPane,
  Tab,
  Tabbar,
  Tabs,
  Text,
  Textarea,
  Thumbnail,
  Toast,
  ToastController,
  Toggle,
  Toolbar,
  ToolbarTitle,
  VirtualScroll
} from './ionic.components.js';

export function defineCustomElements(win, opts) {
  return defineCustomElement(win, [
    ActionSheet,
    ActionSheetController,
    Alert,
    AlertController,
    Anchor,
    AnimationControllerImpl,
    App,
    Avatar,
    BackButton,
    Backdrop,
    Badge,
    Button,
    Buttons,
    Card,
    CardContent,
    CardHeader,
    CardSubtitle,
    CardTitle,
    Checkbox,
    Chip,
    ChipButton,
    ChipIcon,
    Col,
    Content,
    Datetime,
    Fab,
    FabButton,
    FabList,
    Footer,
    Grid,
    Header,
    HideWhen,
    Icon,
    Img,
    InfiniteScroll,
    InfiniteScrollContent,
    Input,
    Item,
    ItemDivider,
    ItemGroup,
    ItemOption,
    ItemOptions,
    ItemSliding,
    Label,
    List,
    ListHeader,
    Loading,
    LoadingController,
    Menu,
    MenuButton,
    MenuController,
    MenuToggle,
    Modal,
    ModalController,
    Nav,
    NavPop,
    NavPush,
    NavSetRoot,
    Note,
    Picker,
    PickerColumnCmp,
    PickerController,
    Popover,
    PopoverController,
    Radio,
    RadioGroup,
    Range,
    Refresher,
    RefresherContent,
    Reorder,
    ReorderGroup,
    RippleEffect,
    Route,
    RouteRedirect,
    Router,
    RouterOutlet,
    Row,
    Searchbar,
    Segment,
    SegmentButton,
    Select,
    SelectOption,
    SelectPopover,
    ShowWhen,
    SkeletonText,
    Slide,
    Slides,
    Spinner,
    SplitPane,
    Tab,
    Tabbar,
    Tabs,
    Text,
    Textarea,
    Thumbnail,
    Toast,
    ToastController,
    Toggle,
    Toolbar,
    ToolbarTitle,
    VirtualScroll
  ], opts);
}
